import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { ListSubheader, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  groupLabel: {
    backgroundColor: '#eeeeee',
    fontWeight: theme.typography.fontWeightBold,
    top: theme.spacing(-1),
    borderTop: `1px solid ${theme.palette.divider}`,
    height: theme.spacing(4.5),
    display: 'flex',
    alignItems: 'center'
  },
  groupUl: {
    padding: 0
  }
}));

export const GroupedListSubheader = ({ params }) => {
  const intl = useIntl();
  const classes = useStyles();

  return params.group ? (
    <li key={params.key}>
      <ListSubheader dense component="div" className={classes.groupLabel}>
        {intl.formatMessage({ id: params.group })}
      </ListSubheader>
      <ul className={classes.groupUl}>{params.children}</ul>
    </li>
  ) : (
    <li key={params.key}>
      <ul className={classes.groupUl}>{params.children}</ul>
    </li>
  );
};

GroupedListSubheader.propTypes = {
  params: PropTypes.object
};

export default GroupedListSubheader;
